export const consentDatas = [
    {
        title: "เก็บผลการตรวจทางการแพทย์และผลตรวจสารเสพติด",
        details: "เก็บรวบรวม ใช้ และเปิดเผยผลตรวจทางการแพทย์และผลตรวจสารเสพติดเพื่อรับรองว่าสุขภาพของข้าพเจ้าอยู่ในระดับที่จะสามารถปฏิบัติงานได้อย่างดีที่สุด และไม่มีโรคติดต่อ",
        name: "isDrug"
    },
    {
        title: "บันทึกประวัติสุขภาพ",
        details: "เก็บรวบรวม ใช้ และเปิดเผย สภาพร่างกาย ประวัติสุขภาพและประวัติ การลาป่วย ต่อสภากาชาดไทย เพื่อใช้ในการประเมินความสามารถในการทํางานจากสุขภาพ การจัดหรือให้สวัสดิการแก่บุคลากร และการให้ความช่วยเหลือแก่บุคลากรในการทํางาน",
        name: "isHealth"
    },
    {
        title: "ข้อมูลศาสนา",
        details: "เก็บรวบรวม ใช้ และเปิดเผยข้อมูลศาสนา เพื่อการจัดสวัสดิการที่เหมาะสมให้กับเจ้าของข้อมูลผู้นับถือศาสนาต่างๆ",
        name: "isRelegion"
    },
    {
        title: "ข้อมูลชีวภาพ (ได้แก่ภาพสแกนลายนิ้วมือและภาพสแกนหน้า)",
        details: "ให้สภากาชาดไทย เก็บรวบรวม ใช้ภาพสแกนลายนิ้วมือและภาพสแกนหน้าเพื่อใช้ในระบบควบคุมประตูเข้า-ออก และบันทึกเวลาการเข้า-ออกงาน",
        name: "isBio"
    },
    {
        title: "ประวัติอาชญากรรม",
        details: "เก็บรวบรวม และใช้ประวัติอาชญากรรมของข้าพเจ้า เพื่อพิจารณารับบุคคลเข้าทำงาน หรือตรวจสอบคุณสมบัติของบุคคล",
        name: "isCriminal"
    },
    {
        title: "ผู้ประมวลผลข้อมูลส่วนภายนอก",
        details: "เปิดเผยข้อมูลตามข้อ 1 - ข้อ 2 ไปยังผู้รับจ้างหรือผู้ให้บริการภายนอกของสภากาชาดไทย เพื่อวัตถุประสงค์ของกิจกรรมตามที่ระบุไว้ในข้อ 1 - ข้อ 2",
        name: "isExternalData"
    },
    {
        title: "โปรดระบุวัตถุประสงค์อื่น ๆ (ถ้ามี)",
        name: "isOther"
    },
    {
        title: "ให้ความยินยอมตามข้อ 1 - ข้อ 7 ข้างต้นทุกข้อ",
        name: "isAll"
    },
]
